import type { FaireProductEntity } from "../../entity_types/product";

export const p_wtbx4bz3sh: FaireProductEntity = {
  token: "p_wtbx4bz3sh",
  type: "product",
  name: "Uncle's Big Green Curry",
  brandToken: "b_9fdtkkw55p",
  brandName: "Uncle's Thai Food",
  imageUrl:
    "https://cdn.faire.com/fastly/c31369a1d3da790311f72dc29dbbcea4374544ab6c1be11e1fe06889856845d2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6951abcf5408ebd08a5aa5626feaebcffad1c9f635ee3c72a03c782f017eaf9e.jpeg",
    "https://cdn.faire.com/fastly/4ec2c064320574e46ff37f44cd49a6ebce37b65a2167c27ffa60b5c58c7ac1aa.jpeg",
    "https://cdn.faire.com/fastly/b304535086d902e32a515d2b58dfbe1f6f560f5fc09b5c7104358dcddf0b0fe0.jpeg",
    "https://cdn.faire.com/fastly/edf6913d0dcb1863b5df831f4f392bd8b07fd93cedb0d95e2bd2487eeea72e52.jpeg",
    "https://cdn.faire.com/fastly/55d1dfcb87fe21ba7b7e566052d8163bdf5d7b392d3ec6cf0c347949e369d097.jpeg",
  ],
  priceDollars: 9,
  description:
    "Big Green is our all-purpose curry: ideal for when you’re short on time, hoping to impress, or just need to clear the fridge. It's herbaceous, not too sweet, and perfectly spicy.\n\nHow To Use:\nUncle’s Curry Blocks are sourced, cooked, and freeze-dried in Thailand, complete with coconut milk. All you have to do is cook your choice of meat and vegetables, drop in the block, then add water.\n\nWhy Freeze Dried:\nFreeze-drying preserves flavor and nutrients—all without the need for additives, flavor enhancers, or chemicals.\n",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:16:57.269Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
